import type { ReactNode } from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../lib/auth/auth-context";
import { useIsAdmin } from "../lib/auth/use-is-admin";
import { SplashScreen } from "./SplashScreen";

export function AdminRoute({ children }: { children: ReactNode }) {
  const { status } = useAuth();
  const isAdmin = useIsAdmin();
  if (status === "loading") return <SplashScreen />;
  if (status === "unauthenticated") return <Navigate to="/sign-in" replace />;
  if (!isAdmin) return <Navigate to="/" replace />;
  return <>{children}</>;
}
